module.exports = __webpack_public_path__ + "img/fluent-mdl2_bulk-upload.85944a04.svg";